const lastMileSolutionRoutes = {
  createFleetManagement: "/createFleetManagement",
  getFleetManagement: "/getFleetManagement",
  updateFleetManagement: "/updateFleetManagement",
};

export default lastMileSolutionRoutes;
